module.exports = __webpack_public_path__ + "assets/apply1.c54b1fa5.svg";